// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".473e24ce1b842a1d8c07643409bbe9d0757b5c34.chunk.js";
};